export const ALERTS_COUNT_PER_REQUEST = 20;
